// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7e65b4b3","367":"1ded6d53","453":"ffcf1344","455":"2c4939bc","458":"553bb076","977":"ca6e7e81"}[chunkId] + ".chunk.js";
};